import { Typography as MuiTypography, TypographyProps, useTheme } from '@mui/material';
import { memo } from 'react';

export interface ITypography extends TypographyProps {
  value?: React.ReactNode;
  size?: 'default' | 'large';
}

export const CustomTypography = memo(
  ({
    value,
    size,
    variant = 'body2',
    fontSize,
    fontWeight,
    color,
    ...rest
  }: ITypography) => {
    const theme = useTheme();

    return (
      <MuiTypography
        variant={variant}
        fontSize={fontSize ?? (size ? (size === 'large' ? '1.25rem' : undefined) : undefined)}
        fontWeight={fontWeight ?? (variant === 'body2' ? theme.typography.fontWeightRegular : undefined)}
        color={color ?? theme.palette.text.secondary}
        {...rest}
      >
        {value}
      </MuiTypography>
    );
  },
);
